import { jsxs as l, jsx as e } from "react/jsx-runtime";
import { az as f, t as _, d as c, j as u } from "../../vendor-EQDp64ng.js";
import "react";
import "../../theme/spacing.js";
import { omitStyleRenderProps as p } from "../../utils/omitStyleRenderProps/index.js";
import { BaseIcon as a } from "../BaseIcon/index.js";
import { FieldDescription as b } from "../FieldDescription/index.js";
import { FieldError as F } from "../FieldError/index.js";
import { FieldLabel as $ } from "../FieldLabel/index.js";
import { Input as I } from "../Input/index.js";
import '../../assets/index45.css';const x = "_label_h4r4c_1", z = "_decoration_h4r4c_5", N = "_clearButton_h4r4c_15", B = "_searchIcon_h4r4c_25", C = "_searchField_h4r4c_33", S = "_fieldControl_h4r4c_48", W = "_input_h4r4c_59", j = "_horizontal_h4r4c_81", v = "_fullWidth_h4r4c_99", o = {
  label: x,
  decoration: z,
  clearButton: N,
  searchIcon: B,
  searchField: C,
  fieldControl: S,
  input: W,
  horizontal: j,
  fullWidth: v
}, A = ({
  label: t,
  description: n,
  errorMessage: i,
  fullWidth: s = !1,
  horizontal: d = !1,
  placeholder: h = "Search",
  autoFocus_I_READ_THE_JSDOC: m,
  ...r
}) => /* @__PURE__ */ l(
  f,
  {
    ...p(r),
    autoFocus: m,
    className: c(o.searchField, {
      [o.fullWidth]: s,
      [o.horizontal]: d
    }),
    "data-component": "SearchField",
    children: [
      /* @__PURE__ */ e($, { className: o.label, children: t }),
      /* @__PURE__ */ l(_, { className: o.fieldControl, children: [
        /* @__PURE__ */ e("span", { className: c(o.decoration, o.searchIcon), children: /* @__PURE__ */ e(a, { icon: "search", size: "sm", color: "moon" }) }),
        /* @__PURE__ */ e(
          I,
          {
            autoComplete: "off",
            placeholder: h,
            className: o.input,
            "aria-label": r["aria-label"],
            onInput: r.onInput,
            value: r.value
          }
        ),
        /* @__PURE__ */ e(u, { className: c(o.decoration, o.clearButton), children: /* @__PURE__ */ e(a, { icon: "close", size: "sm", color: "moon" }) })
      ] }),
      /* @__PURE__ */ e(b, { children: n }),
      /* @__PURE__ */ e(F, { children: i })
    ]
  }
);
export {
  A as SearchField
};
